import { render, staticRenderFns } from "./ShopTutorial.vue?vue&type=template&id=39bd276a&scoped=true&"
import script from "./ShopTutorial.vue?vue&type=script&lang=js&"
export * from "./ShopTutorial.vue?vue&type=script&lang=js&"
import style0 from "./ShopTutorial.vue?vue&type=style&index=0&id=39bd276a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bd276a",
  null
  
)

export default component.exports